/** 頁面判斷工具 */
export function usePage() {
  /** 檢查目前是否在加入會員頁面 */
  function checkIsJoinUsPage() {
    return location.href.includes('join-us')
  }

  return {
    /** 檢查目前是否在加入會員頁面 */
    checkIsJoinUsPage
  }
}
